import {ProvisionBookingKind} from './provision-booking-kind.enum';
import {provisionEnumLabelFallback} from './provision-enum-label-fallback';

/**
 * German presentation companion of {@link ProvisionBookingKind} — the SINGLE place in the cp
 * frontend that NAMES a booking direction, following the pattern of `provision-run-status-label.ts`.
 *
 * ── THIS FILE PRODUCES A CAPTION, NEVER A SIGN (design gate FD-1 / B1)
 *
 * `bookingKind` is the LABEL of the "Richtung" column and nothing else. The sign of a booking
 * arrives from the backend on `signedAmount` / `runningBalance`, folded over the module's single
 * sign definition (`ProvisionBalanceService.signedAmount`); colouring, totalling and comparing read
 * those delivered numbers. A `bookingKind === CREDIT` branch that produces a sign, negates an amount
 * or picks a colour would plant a second copy of the module's sign rule in TypeScript. Nothing in
 * this file may ever return anything but a caption.
 */
export const CP_BOOKING_KIND_LABELS: Readonly<Record<ProvisionBookingKind, string>> = {
    [ProvisionBookingKind.CREDIT]: 'Gutschrift',
    [ProvisionBookingKind.DEBIT]: 'Forderung'
};

/** German caption of a booking direction; an unmapped constant stays VISIBLE, never blank. */
export function getProvisionBookingKindLabel(bookingKind: ProvisionBookingKind): string {
    return CP_BOOKING_KIND_LABELS[bookingKind]
        ?? provisionEnumLabelFallback(ProvisionBookingKind, bookingKind);
}
